import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaintananceForm from "./MaintananceForm";

function MaintananceFormEdit() {
  const { id,id2 } = useParams();
  return <MaintananceForm id={id} id2={id2} FromCome={"Edit"} />;
}

export default MaintananceFormEdit;
